import apiClient from '@/services/api-base';
import { useWebsocket } from '@/services/websocket';
import { clearFileDB } from "@/utils/indexedDb"
const ws = useWebsocket()

const clear = () => {
    localStorage.clear(); 
    sessionStorage.clear();
    clearFileDB();
}

const logoutApi = (loading) => {
    apiClient.post('account/logout', {}).then(() => {
        console.log('Log off realizado com sucesso')
    })
    .catch((err) => {
        // If the session is already expired/invalid, backend may return 401/403.
        // Logout should still complete locally without triggering a runtime overlay.
        const status = err?.response?.status
        if (status && status !== 401 && status !== 403) {
            // keep a breadcrumb for non-auth errors
            console.warn('Erro ao fazer logout na API', err)
        }
    })
    .finally(() => {
        clear()
        if (loading) {
            loading.value = false
        }
    })
}

const logout = (loading) => {
    ws.disconnect()
    if (loading) {
        logoutApi(loading)
    } else {
        clear()
    }
}
export default logout